module.exports = __webpack_public_path__ + "img/sbl0015.2948728f.png";